import MultiSelect from 'components/MultiSelect';
import { FiltersTreeContext } from 'contexts/ExploreFiltersTreeContext';
import React, { useContext } from 'react';
import logEvent from 'utils/analytics';

type ComponentProps = {
  options: {
    [key: string]: string;
  };
  filter: string;
  notFilter?: string;
  allowMultipleValues?: boolean;
  treeContext: React.Context<FiltersTreeContext>;
};

const MultiSelectFilter: React.FC<ComponentProps> = (props) => {
  const { options, filter, notFilter = '', allowMultipleValues = false, treeContext } = props;

  const { treeParams, handleAddValueToTree, handleRemoveValueFromTree } = useContext(treeContext);

  const filters = (treeParams[filter] ?? []) as string[];
  const notFilters = (treeParams[notFilter] ?? []) as string[];

  const handleChange = (key: string): void => {
    if (filters.includes(key)) {
      handleRemoveValueFromTree(key, filter);
    } else if (notFilters.includes(key)) {
      handleRemoveValueFromTree(key, notFilter);
    } else {
      handleAddValueToTree(key, filter, options[key], !allowMultipleValues);
    }
    logEvent(`envelopes-list-filter-${filter}`);
  };

  const selected: string[] = [];
  filters.forEach((v) => {
    if (options[v]) {
      selected.push(v);
    }
  });

  const notSelected: string[] = [];
  notFilters.forEach((v) => {
    if (options[v]) {
      notSelected.push(v);
    }
  });

  return (
    <div className="mt-1">
      <MultiSelect
        options={options}
        onChange={handleChange}
        selectedItems={selected}
        notSelectedItems={notSelected}
        labelClasses="text-white font-normal text-xss"
        prefix={filter}
      />
    </div>
  );
};

export default MultiSelectFilter;
